import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { imagePreviewStyles } from '../../../../styled/common';

export const PhotoWrapper = styled.div<{
  $isHighAndThick: number | null;
  $isBeforeHighAndThick: boolean;
}>`
  ${imagePreviewStyles};

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 300px;
  }

  &:nth-child(5n) {
    grid-column: span 2;
    grid-row: span 2;

    @media (min-width: ${Breakpoints.tablet}px) {
      height: 460px;
    }
  }

  ${({ $isHighAndThick }) =>
    $isHighAndThick &&
    css`
      grid-row: span 2;
    `};

  ${({ $isBeforeHighAndThick }) =>
    $isBeforeHighAndThick &&
    css`
      grid-column: 1/2;
    `};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    grid-column: auto;
    grid-row: auto;
    height: 330px;

    &:nth-child(5n) {
      height: 330px;
      grid-column: auto;
      grid-row: auto;
    }
  }
`;

export const StyledPhoto = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
